Wee.fn.make('newsletter', {
	init: function() {
		var $input = $('ref:newsletterInput'),
			$label = $('ref:newsletterLabel');


		if ($input.val() === '') {
			$label.show();
		}

		$.events.on({
			'ref:newsletterInput': {
				focus: function() {
					$label.hide();
				},
				blur: function() {
					if ($input.val() === '') {
						$label.show();
					}
				}
			}
		}, {
			namespace: 'newsletter'
		});
	},
	unload: function() {
		$.events.off(null, '.newsletter');
	}
});
